import { gql } from '@apollo/client';

export default gql`
  query UserNotificationsByPanelIdQuery(
    $panelId: Int!
    $notificationType: NotificationTypeEnum
  ) {
    notifications: allNotificationTypes(
      condition: { panelId: $panelId, notificationType: $notificationType }
    ) {
      totalCount
      nodes {
        id
      }
    }
  }
`;
